export default __webpack_public_path__ + "9d6274ab88d3bd85fa19c8c26f357684.svg";